import React, { useState } from "react";
import { ShowFeature } from "../../../assets/icons/showFeatures";
import { CloseFeature } from "../../../assets/icons/closeFeatures";
import CustomButton from "../../CustomButton";
import useWindowWidth from "../../../hooks/useBetterMediaQuery";
import "../../../styles/components/Slices/CaseStudyMonet.scss";
const CaseStudyMonet = ({ slice, location }) => {
  const array = [
    { uid: "all", label: "All" },
    { uid: "Physical AI", label: "Physical AI" },
    { uid: "Logistics", label: "Logistics" },
    { uid: "Retail & E-Commerce", label: "Retail & E-Commerce" },
    { uid: "Healthcare", label: "Healthcare" },
    { uid: "Agriculture", label: "Agriculture" },
    { uid: "Insurance", label: "Insurance" },
    { uid: "Sports", label: "Sports" },
  ];

  const tagMap = {
    "Physical AI": {
      label: "Physical AI",
    },
    "human-safety": {
      label: "Human Safety",
    },
    "generative-ai": {
      label: "Generative AI",
    },
    "consumer-ad-intelligence": {
      label: "Consumer/Ad Intelligence",
    },
    "cv-platform": {
      label: "CV Platform",
    },
    insurance: {
      label: "Insurance",
    },
    sports: {
      label: "Sports",
    },
    "retail-e-commerce": {
      label: "Retail & E-Commerce",
    },
    agriculture: {
      label: "Agriculture",
    },
    logistics: {
      label: "Logistics",
    },
    "smart-cities": {
      label: "Smart Cities",
    },
    healthcare: {
      label: "Healthcare",
    },
    default: { label: null },
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [showMore, setShowMore] = useState(false);
  const [showMoreCards, setShowMoreCards] = useState(false);
  const ShowMoreCards = () => setShowMoreCards(!showMoreCards);
  const ShowMoreTags = () => setShowMore(!showMore);

  const activeTag = array[activeIndex].uid;

  const filtered = slice?.filter((item) => {
    if (activeTag === "all") return true;
    return item?.node?.tags?.some?.(
      (tag) => tag.toLowerCase() === activeTag.toLowerCase()
    );
  });
  //show 4 cards
  const filteredCardsToshowInitially = filtered?.slice(0, 4) || [];
  const neededRemaining = 4 - filteredCardsToshowInitially.length;

  const remaining = slice?.filter((item) => !filtered.includes(item)) || [];

  const remainingCardstoShowInitially = remaining?.slice(0, neededRemaining);

  const filteredRemainingCards = filtered?.slice(4);
  const remainingCards = remaining?.slice(neededRemaining);

  const isDesktop = useWindowWidth(1023);
  const isTablet = useWindowWidth(640);
  const isMobile = useWindowWidth(318);
  const heightPerCard = isDesktop ? 425 : isTablet ? 725 : isMobile ? 592 : 0;
  const scrollToSection = (url) => {
    if (url && url?.charAt(0) === "#") {
      const sectionId = url.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - 90;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    } else toggleModal();
  };

  const renderCard = (item, index) => {
    const tag = tagMap[item?.tags?.uid] || tagMap.default;
    const secondary = tagMap[item?.secondary_tag?.uid] || tagMap.default;

    return (
      <a
        href={`/customers/${item?.node?.uid}`}
        key={index}
        className={`flex lg:flex-row rounded-[10px] group flex-col gap-4 sm:gap-6 p-4 sm:p-6 items-center ease-in-out duration-500 bg-[#FFFFFF] border border-gray-1600 hover:border-[#BEBFC2] hover:bg-gray-3007 `}
      >
        <div className="relative">
          <div
            className={`absolute inset-0 z-0 rounded-md img-gradient transition-opacity ease-linear`}
          />
          <img
            className="max-w-full lg:max-w-[380px] lg:h-[324px] rounded-md object-cover"
            src={item?.node?.data?.image?.url}
            alt={item?.node?.data?.image?.alt || "Card Cover Image"}
          />
          {item?.node?.data?.sub_image?.url && (
            <img
              className="absolute max-w-[117px] sm:max-w-[140px] lg:max-w-[129px] top-[18px] left-5"
              src={item?.node?.data?.sub_image?.url}
              alt={item?.node?.data?.sub_image?.alt || "Card Logo Image"}
            />
          )}
        </div>
        <div className="flex flex-col gap-3 lg:mb-5 lg:mt-auto w-full">
          <p className="text-xl sm:text-2xl font-manrope font-semibold text-purple-1100 -tracking-[1.2px]">
            {item?.node?.data?.title?.text}
          </p>
          <p
            className="text-sm sm:text-lg font-normal -tracking-[0.8px] text-gray-600 overflow-hidden"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
            }}
          >
            {item?.node?.data?.content.text
              .replace(/\{\{[^}]+\}\}/g, "")
              .trim()}
          </p>
          <div className="mt-auto pb-5 pt-10">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3 flex-wrap">
                {item?.node?.tags
                  ?.filter((tag) => tag.toLowerCase() !== "customers")
                  .map((tag, index) => (
                    <p
                      key={index}
                      className="py-1 px-2.5 rounded-md text-xs font-manrope font-semibold -tracking-tighter uppercase text-[#77787A] bg-gray-1600"
                    >
                      {tag}
                    </p>
                  ))}
              </div>

              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="ml-auto transition-transform duration-300 ease-in-out group-hover:translate-x-2.5"
              >
                <path
                  d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                  fill="#434343"
                />
              </svg>
            </div>
          </div>
        </div>
      </a>
    );
  };

  return (
    <>
      <section className="relative px-4 mx-auto sm:px-12 lg:px-5 xl:px-0 max-w-6xl">
        <div
          className={`flex flex-col ${showMore && "border-b"} gap-3 lg:gap-0 lg:flex-row lg:border-b lg:justify-between`}
        >
          {/* Mobile Toggle Filter */}
          <div
            className="border-t lg:hidden border-b flex items-center justify-between py-3"
            onClick={ShowMoreTags}
          >
            <div className="text-lg font-manrope">
              Filter:{" "}
              <span className="font-manrope text-lg font-semibold text-purple-1500 -tracking-[0.9px]">
                {array[activeIndex].label}
              </span>
            </div>
            <div className="px-6">
              {showMore ? <CloseFeature /> : <ShowFeature />}
            </div>
          </div>

          {/* Mobile Tag List */}
          <div
            className={`transition-all flex flex-col gap-3 ease-in-out duration-700 overflow-hidden ${
              showMore ? "max-h-[1000px]" : "max-h-0"
            }`}
          >
            {array.map((tag, index) => {
              const isActive = activeIndex === index;
              return (
                <div
                  key={index}
                  onClick={() => {
                    setActiveIndex(index);
                    ShowMoreTags();
                  }}
                  className={` text-lg lg:hidden  -tracking-[0.9px] lg:px-4 xl:px-6 px-6 py-1.5 lg:py-2 flex flex-row cursor-pointer 
                  ${isActive ? "rounded-[10px] text-purple-1500 font-manrope font-semibold bg-[#5e44ff0d]" : "font-inter font-normal"}`}
                >
                  {tag.label}
                </div>
              );
            })}
          </div>

          {/* Desktop Tag List */}
          {array.map((tag, index) => {
            const isActive = activeIndex === index;
            return (
              <div
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`hidden lg:flex text-lg font-normal -tracking-[0.9px] lg:px-4 xl:px-6 px-6 py-1.5 lg:py-2 
      hover:border-b hover:border-b-gray-3008 hover:text-gray-3008 flex-row cursor-pointer 
      transition-all duration-300 ease-in-out 
      ${isActive ? "lg:border-b lg:border-b-purple-1500 text-purple-1500" : "text-gray-2700"}`}
              >
                {tag.label}
              </div>
            );
          })}
        </div>
      </section>

      <section className="relative px-4 mx-auto sm:px-12 lg:px-5 xl:px-0 max-w-6xl">
        {filtered?.length === 0 && (
          <p className="text-center py-10 items-center text-2xl font-bold font-manrope">
            No Case Study Found
          </p>
        )}
        {filtered?.length <= 2 ? (
          <>
            <div className="flex flex-col gap-6 mt-6">
              {filtered.map(renderCard)}
            </div>
            <CustomButton
              onClick={() => scrollToSection("#read-more")}
              text="Continue reading below"
              direction={"bottom"}
              icon={<ShowFeature />}
              buttonClass={`text-center mx-auto my-3 text-gray-2500 sm:my-5 hover:text-gray-2700 font-manrope text-base py-2 rounded-[10px] font-semibold bg-[#F0F0F0] -tracking-tight_1`}
            />

            <div className="scroll-mt-20 flex flex-col gap-6" id="read-more">
              {remainingCardstoShowInitially.map(renderCard)}
            </div>

            <div
              className={`transition-all duration-700 ease-in-out overflow-hidden ${
                showMoreCards ? "= opacity-100" : "= opacity-0"
              }`}
              style={{
                maxHeight: showMoreCards
                  ? `${heightPerCard * (remainingCards?.length || 0)}px`
                  : "0px",
              }}
            >
              <div className="flex flex-col gap-6 mt-6">
                {remainingCards.map(renderCard)}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col gap-6 mt-6">
              {filteredCardsToshowInitially.map(renderCard)}
            </div>

            <div
              className={`transition-all duration-700 ease-in-out overflow-hidden ${
                showMoreCards ? ` opacity-100` : "max-h-0 opacity-0"
              }`}
              style={{
                maxHeight: showMoreCards
                  ? `${heightPerCard * filteredRemainingCards?.length}px`
                  : "0px",
              }}
            >
              <div className="flex flex-col gap-6 mt-6">
                {filteredRemainingCards.map(renderCard)}
              </div>
            </div>
          </>
        )}
      </section>
      {filtered?.length > 2 && filtered?.length <= 4 ? null : showMoreCards ? (
        <CustomButton
          text="Show less"
          icon={<CloseFeature />}
          buttonClass="text-gray-2500 my-5 hover:text-gray-2700 bg-gray-1600 text-base mx-auto"
          direction="top"
          onClick={ShowMoreCards}
        />
      ) : (
        <CustomButton
          text="Show more"
          icon={<ShowFeature />}
          buttonClass="text-gray-2500 my-5 hover:text-gray-2700 bg-gray-1600 text-base mx-auto"
          direction="bottom"
          onClick={ShowMoreCards}
        />
      )}
    </>
  );
};

export default CaseStudyMonet;
